import { darkTheme, lightTheme } from '../../theme';
import { DARK } from '../../utils/constants';

export default (options, theme) => {
  const currentTheme = theme === DARK ? darkTheme : lightTheme;
  return {
    ...options,
    colors: {
      ...options.colors,
      primary: currentTheme.palette.secondary.main,
      primary25: currentTheme.palette.secondary.light,
      primary50: currentTheme.palette.secondary.main,
    },
  };
};
